import basicController from "servicestack/basic.controller.properties";
import templateUrl from "emun.customer/customer-tags.htm";
import AutoQuery from "servicestack/auto-query/auto-query";
import RetailerTagsPrompt from "servicestack/tags/tags-prompt";

class CustomerTagsController {
  constructor($rootScope, NgMap, $timeout, $window) {
    const $ctrl = this;
    basicController($ctrl);

    let options = {
      url: "QueryRetailers.json?Id=" + $ctrl.customerId,
      fields: "Id,CompanyName,Tags",
      pageSize: 1,
      autoLoad: !$ctrl.customer && $ctrl.customerId,
      append: false,
      onLoaded(args) {
        if (args.total === 0) {
          return alert("Could not find: " + $ctrl.customerId);
        }
        $ctrl.customer = args.first;
        $ctrl.tags = args.first.tags;
      }
    };
    $ctrl.query = new AutoQuery(options);
  }
  editTags() {
    const $ctrl = this;
    return RetailerTagsPrompt.open({
      title:
        $ctrl.customer.id +
        " - " +
        $ctrl.customer.companyName +
        " " +
        ($ctrl.title || "Tags..."),
      tagKinds: $ctrl.tagKinds,
      request: $ctrl.customer
    }).then(() => $ctrl.query.load(true));
  }
}

let CustomerTags = {
  bindings: {
    title: "@",
    customerId: "@",
    tags: "<?",
    customer: "<?",
    tagKinds: "<?"
  },
  controller: CustomerTagsController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};

export default CustomerTags;
